import React from 'react';
import { HotelOfferCard } from '@americanexpress/consumer-travel-base';
import {
  isLoaded, isLoading, loadModule, RenderModule,
} from 'holocron';
import { getIsLoggedInSelector, getHasAuthLoadedSelector } from '@americanexpress/travel-selectors';
import { useDispatch, useSelector } from 'react-redux';
import { HotelOfferData } from '../../../types/PersonalizedMarketingArticles';
import { WISHLIST_MODULE_NAME } from '../../../constants/moduleConstants';

type HotelOfferProps = {
  offer: HotelOfferData,
  element: string,
  isHorizontal?: boolean,
  handleDrawerOpen: () => void,
};

export const HotelOffer = ({
  offer, element, isHorizontal, handleDrawerOpen,
}: HotelOfferProps) => {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector(getIsLoggedInSelector);
  const hasAuthLoaded = useSelector(getHasAuthLoadedSelector);
  const isMember = Boolean(hasAuthLoaded && isLoggedIn);
  const isWishlistLoaded = useSelector(isLoaded(WISHLIST_MODULE_NAME));
  const isWishlistLoading = useSelector(isLoading(WISHLIST_MODULE_NAME));
  if (isMember && !isWishlistLoaded && !isWishlistLoading) {
    dispatch(loadModule(WISHLIST_MODULE_NAME));
  }
  const wishlist = (
    <RenderModule
      moduleName={WISHLIST_MODULE_NAME}
      props={{
        itemSourceId: offer?.lxpId,
        propertyName: offer.title,
      }}
    />
  );

  const hasOffer = offer.showTagIcon || false;

  return (
    <HotelOfferCard
      orientation={isHorizontal ? 'horizontal' : 'vertical'}
      hotelHref={offer.hotelHref}
      img={{ src: offer.imageUrl }}
      program={offer.program}
      title={offer.title}
      subtitle={offer.subtitle}
      offer={{
        text: offer.offerText,
        ...hasOffer
          ? { dateConditionsText: offer.dateConditionsText }
          : {},
      }}
      showTagIcon={hasOffer}
      termsText={offer.termsDrawer.buttonText}
      // eslint-disable-next-line react/jsx-props-no-spreading -- need to render href when no offer
      {...(hasOffer
        ? { onTermsClick: handleDrawerOpen }
        : { termsHref: offer.hotelHref }
      )}
      wishlistIcon={(isMember && isWishlistLoaded) && wishlist}
      analytics={{
        analyticsElement: element,
        isTrackImpressions: true,
        termsApplyReactlytics: {
          element: offer.program,
          type: 'click',
          detail: 'Open:Terms Panel',
        },
        titleLinkReactlytics: {
          element,
          type: 'click',
          detail: offer.title,
        },
      }}

    />
  );
};
